import _                                                    from 'underscore';
import React                                                from 'react';
import { Align }                                            from "@src/types";
import { ProjectActivityBulkUpdateShellFormContainerProps } from "@src/views/pages/projects/activities/bulk/ProjectActivityBulkUpdateShell";
import { QueryDialogProps, QueryOpDialog }                  from "@src/views/components/from-query/QueryOpDialog";
import { BasicDialogContainer }                             from "@src/views/components/modals/BasicDialogContainer";


interface ProjectActivityBulkUpdateDialogFormContainerProps extends QueryDialogProps, ProjectActivityBulkUpdateShellFormContainerProps {
    title?: string,
}

const ProjectActivityBulkUpdateDialogFormContainerDefaultProps = {
    title: 'Bulk Update',
} satisfies Partial<ProjectActivityBulkUpdateDialogFormContainerProps>

function ProjectActivityBulkUpdateDialogFormContainer( { children, ...p }: ProjectActivityBulkUpdateDialogFormContainerProps ){

    const props = { ...ProjectActivityBulkUpdateDialogFormContainerDefaultProps, ...p } as ProjectActivityBulkUpdateDialogFormContainerProps;

    return (
        <QueryOpDialog
            showOperationInTransitMessage={ false }
            showOperationInTransitOnSubmit={ true }
            operationDisabled={ props.operationDisabled }
            closeIsDisabled={ props.isProcessing || props.isLoading }
            mutation={ props.mutation }
            graphArgs={ props.getGraphArgs }
            confirmationHandler={ null }
            onSubmit={ props.onSubmit }
            onComplete={ props.onComplete }
            onError={ props.onError }
            onClose={ props.onClose }
            cancelLabel={ 'Close' }
            submitLabel={ 'Update Activity Set' }
            successToastLabel={ null }
            overflow={ true }
            className={ 'no-padding' }
            alignControls={ Align.CENTER }
            { ..._.omit( props, _.keys( ProjectActivityBulkUpdateDialogFormContainerDefaultProps ) ) }>

            <BasicDialogContainer title={ props.title } contentPadding={ null } overflow={ true }>

                { children }

            </BasicDialogContainer>

        </QueryOpDialog>
    );
}

export {
    ProjectActivityBulkUpdateDialogFormContainer,
    ProjectActivityBulkUpdateDialogFormContainerDefaultProps,
    type ProjectActivityBulkUpdateDialogFormContainerProps,
};
